<template>
  <div class="overflow-auto">
    <div v-if="data && data.length > 0">
      <div v-if="type == 'transfer'">
        <b-card
          v-for="(item, index) in data"
          no-body
          class="px-3 py-1 mb-2 mt-3 block-list-history"
          :key="index"
        >
          <b-card-header header-tag="header" class="p-0" role="tab">
            <b-row
              v-b-toggle="'remittance_' + index"
              class="d-flex align-items-center"
            >
              <div class="px-3 d-flex align-items-center">
                <div class="fz-16 fw-700 d-flex flex-column">
                  {{
                    item.fundType == "in" ? item.payerName : item.payeeUserName
                  }}
                  <!-- <span class="mr-3">{{ item.payerBankAccountName }}</span> -->
                  <div class="fz-14 fw-700 text-grey7">
                    {{ maskUserNo(item.userNo) }}
                  </div>
                </div>
                <div
                  :class="
                    'ml-3 badge-default text-nowrap badge-' +
                    item.status.toLowerCase()
                  "
                >
                  {{
                    $t(
                      item.status.charAt(0).toUpperCase() + item.status.slice(1)
                    )
                  }}
                </div>
              </div>
              <div class="px-3 ml-auto d-flex flex-column">
                <div class="fz-14 fw-700">
                  {{ item.fundType == "in" ? "+" : "-" }} {{ item.payerCcy }}
                  {{ getPrice(parseFloat(item.payerAmt)) }}
                </div>
                <div class="fz-14 fw-400 text-grey7">{{ item.updated_at }}</div>
              </div>
              <div class="mr-2" v-if="item.status.toLowerCase() == 'approved'">
                <button class="btn btn-secondary" @click="viewDetails(item)">
                  {{ $t("View Details") }}
                </button>
              </div>
            </b-row>
          </b-card-header>
          <b-collapse
            :id="'remittance_' + index"
            accordion="my-accordion"
            role="tabpanel"
            class="expand"
          >
            <b-card-body class="px-2 pt-0">
              <hr />
              <div class="d-flex mb-2">
                <div>{{ $t("Transaction Number") }}</div>
                <div class="ml-auto fw-500">{{ item.userReqNo }}</div>
              </div>
              <div class="d-flex mb-2">
                <div>{{ $t("Payer Bank Account Name") }}</div>
                <div class="ml-auto fw-500">
                  {{ item.payerName }}
                </div>
              </div>
              <div class="d-flex mb-2">
                <div>{{ $t("Payer Merchant Account Number") }}</div>
                <div class="ml-auto fw-500">{{ item.userNo }}</div>
              </div>
              <div class="d-flex">
                <div>{{ $t("Transfer Amount") }}</div>
                <div class="ml-auto fw-500">
                  {{ item.payerCcy }}
                  {{ getPrice(parseFloat(item.payerAmt)) }}
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <div v-else>
        <div class="px-3 py-1 mb-0 mt-3" v-for="item in data">
          <div class="d-flex align-items-center">
            <div class="px-3 d-flex flex-column">
              <div class="fz-16 fw-700 d-flex">
                <span class="mr-2">{{ item.payeeAccountName }}</span>
                <div
                  :class="
                    'ml-auto badge-default badge-' + item.status.toLowerCase()
                  "
                >
                  {{
                    $t(
                      item.status.charAt(0).toUpperCase() + item.status.slice(1)
                    )
                  }}
                </div>
              </div>
              <div class="fz-14 fw-700 text-grey7">{{ item.payeeUserNo }}</div>
            </div>
            <div class="px-3 ml-auto d-flex flex-column">
              <div class="fz-14 fw-700">
                {{ item.fundType == "in" ? "+" : "-" }} {{ item.payerCcy }}
                {{ getPrice(parseFloat(item.payerAmt)) }}
              </div>
              <div class="fz-14 fw-400 text-grey7">{{ item.updated_at }}</div>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </div>
    <div v-else class="text-center p-4 fz-20 text-grey7 fw-500">
      {{ $t("No history found") }}
    </div>

    <div v-if="isLoading" class="dot-loading mt-3">
      <ul class="loader-circle">
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
  </div>
</template>

<script>
import Account from "@/services/Account";
import CreateAccount from "@/services/CreateAccount";
import Transfer from "@/services/Transfer";
import Recipient from "@/services/Recipient";
import Global from "@/services/Global";
import moment from "moment";

const STATUS = {
  1: "Pending",
  2: "Pending",
  3: "Approved",
  4: "Rejected",
};

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL !== "/" ? process.env.BASE_URL : "",
      isLoading: false,
      data: [],
      payeeList: [],
      recipientList: [],
      search: "",
    };
  },
  props: ["type"],
  methods: {
    viewDetails(item) {
      sessionStorage.setItem("transferData", JSON.stringify(item));
      window.open("/va-payout.html", "_blank");
    },
    getPrice(amount) {
      return Global.addCommas(amount);
    },

    async transferList(user_no) {
      let self = this;

      if (this.type == "transfer") {
        try {
          const response = await Transfer.transferList({ userNo: user_no });
          if (response.status == 200) {
            // ambil data recipient
            await self.getRecipient();

            const rawData = response.data.data;

            // Proses data dan fetch sub account secara paralel
            const processedData = await Promise.all(
              rawData.map(async (item) => {
                let processedItem = { ...item };
                processedItem.payeeAccountName = item.payerName;

                let userNoArr = item.payeeUserNo.match(/.{1,4}/g);
                for (let i = 0; i < userNoArr.length; i++) {
                  if (i < userNoArr.length - 2) {
                    userNoArr[i] = "****";
                  }
                }

                processedItem.fundType =
                  user_no == item.payeeUserNo ? "in" : "out";
                processedItem.payeeUserNo = userNoArr.join(" ");
                processedItem.updated_at = moment(item.updated_at).format(
                  "DD MMMM YYYY HH:mm:ss"
                );
                processedItem.status = STATUS[item.status];

                // Tunggu hasil getSubAccountList sebelum lanjut
                await self.filterRecipient(processedItem);

                return processedItem;
              })
            );
            self.data = processedData;
          }
        } catch (err) {
          self.checkError(err);
        }
      }

      if (this.type == "consolidation") {
        Account.transferList({
          userNo: user_no,
        }).then((response) => {
          if (response.status == 200) {
            self.data = response.data.data;
            self.data.forEach(function (item, index) {
              for (let j = 0; j < self.payeeList.length; j++) {
                const payee = self.payeeList[j];
                if (item.payeeUserNo == payee.id) {
                  self.data[index].payeeAccountName = payee.accountName;
                }

                let userNo = item.payeeUserNo.match(/.{1,4}/g);
                for (let index = 0; index < userNo.length; index++) {
                  if (index < userNo.length - 2) {
                    userNo[index] = "****";
                  }
                }
                self.data[index].fundType =
                  user_no == item.payeeUserNo ? "in" : "out";
                self.data[index].payeeUserNo = userNo.join(" ");
                self.data[index].updated_at = moment(item.updated_at).format(
                  "DD MMMM YYYY HH:mm:ss"
                );
                self.data[index].status = STATUS[item.status];
              }
            });
          }
        });
      }
    },

    async getRecipient() {
      const self = this;

      try {
        const response = await Recipient.recipientList();
        if (response.status == 200) {
          const data = response.data.data;
          self.recipientList = data;
        }
      } catch (err) {
        self.checkError(err);
      }
    },

    async filterRecipient(data) {
      const self = this;

      // if (data) {
      //   // const recipient = self.recipientList.find(
      //   //   (item) => item.userNo === data.payeeUserNo
      //   // );

      //   if (recipient) {
      //     data.payee;
      //   }
      // }

      console.log("Filtering recipient for data:", data);
    },
    getData() {
      let self = this;
      CreateAccount.list({
        search: self.search,
        start: 0,
        length: -1,
      }).then((response) => {
        if (response.status == 200) {
          const data = response.data.data[0];
          self.transferList(data.userNo);
        }
      });
    },
    doSearch() {},
    handleViewSubAccount(id, userType) {
      this.$router.push({
        path: "/list-sub-account",
        query: {
          account_id: id,
          user_type: userType,
        },
      });
    },
    handleSubAccount(data) {
      this.$emit("sub-account", data);
    },
    checkError(err) {
      this.isLoading = false;
      const response = err.response;
      try {
        if (response.status == 401 && response.data.name == "Unauthorized") {
          localStorage.removeItem("token");
          localStorage.removeItem("member");
          localStorage.removeItem("isFirstTime");
          this.$router.push({
            path: "/login",
          });
        } else {
          if (localStorage.getItem("token")) {
            var msg = response.data ? response.data.message : err.message;
            this.$notify({
              type: "warn",
              text: msg,
            });
          }
        }
      } catch (e) {
        console.log(err);
      }
    },
    maskUserNo(userNo) {
      if (!userNo) return "";
      // Ambil hanya digit
      let clean = userNo.replace(/\D/g, "");
      // Jika kurang dari 20 digit, tetap masking 12 digit awal
      let masked = "";
      if (clean.length > 12) {
        masked =
          "**** **** **** " +
          clean
            .slice(-8)
            .replace(/(.{4})/g, "$1 ")
            .trim();
      } else {
        // Jika kurang dari 12 digit, masking semua kecuali 4 digit terakhir
        masked = clean
          .split("")
          .map((c, i) => (i < clean.length - 4 ? "*" : c))
          .join("")
          .replace(/(.{4})/g, "$1 ")
          .trim();
      }
      return masked;
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      Account.listPayee().then((response) => {
        if (response.status == 200) {
          const data = response.data.data;
          data.forEach(function (item) {
            self.payeeList.push({
              id: item.relationship_userNo,
              text: item.accountName + " - " + item.relationship_userNo,
              accountName: item.accountName,
            });
          });
          self.getData();
        }
      });
    });
  },
  destroyed() {},
};
</script>

<style scoped>
.block-list-history {
  background-color: #f8f9fa;
  padding: 20px 15px !important;
  border-radius: 8px;
}

.card-header {
  background-color: unset !important;
  border: unset !important;
}
.block-account {
  background: #f8f9fa;
  border-radius: 8px;
}
</style>
